import type { AppointmentsActionTypes, AppointmentsState } from './types';

import {
  CLEAR_APPOINTMENTS_FOR_DAY,
  CLEAR_CHECKIN_DATA,
  CLEAR_CHECKIN_TEAM,
  SET_APPOINTMENTS_FOR_DAY,
  SET_CHECKIN_DATA,
  SET_CHECKIN_MODAL_OPEN_STATE,
  SET_CHECKIN_TEAM,
} from './types';

const initialState: AppointmentsState = {
  checkinData: null,
  isCheckInModalOpen: false,
  appointmentsForDay: [],
  checkInTeam: null,
};

const appointmentsReducer = (
  state = initialState,
  action: AppointmentsActionTypes,
): AppointmentsState => {
  switch (action.type) {
    case SET_CHECKIN_DATA:
      return {
        ...state,
        checkinData: action.payload,
      };
    case CLEAR_CHECKIN_DATA:
      return {
        ...state,
        checkinData: null,
      };
    case SET_CHECKIN_MODAL_OPEN_STATE:
      return {
        ...state,
        isCheckInModalOpen: action.payload,
      };
    case SET_APPOINTMENTS_FOR_DAY:
      return {
        ...state,
        appointmentsForDay: action.payload,
      };
    case CLEAR_APPOINTMENTS_FOR_DAY:
      return {
        ...state,
        appointmentsForDay: [],
      };
    case SET_CHECKIN_TEAM:
      return {
        ...state,
        checkInTeam: action.payload,
      };
    case CLEAR_CHECKIN_TEAM:
      return {
        ...state,
        checkInTeam: null,
      };
    default:
      return state;
  }
};

export default appointmentsReducer;
export type { AppointmentsState };
